import { render } from "./Trainning.vue?vue&type=template&id=45d43027"
import script from "./Trainning.vue?vue&type=script&lang=js"
export * from "./Trainning.vue?vue&type=script&lang=js"

import "./Trainning.vue?vue&type=style&index=0&id=45d43027&lang=scss"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__